const localeMonthNames = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const addLeadingZero = (time: number): string => String(time).padStart(2, '0');

export const getLocaleDate = (date: Date, withTime = false): string => {
  const day = date.getDate();
  const month = date.getMonth();
  const hour = date.getHours();
  const minutes = date.getMinutes();

  let result = `${day} ${localeMonthNames[month]}`;

  if (withTime) {
    result += ` ${addLeadingZero(hour)}:${addLeadingZero(minutes)}`;
  }

  return result;
};

export const isWeekendDate = (date: Date): boolean => {
  const dayOfWeek = date.getDay();
  return dayOfWeek === 6 || dayOfWeek === 0;
};

export const isDateToday = (date: Date, curDate = new Date()): boolean => {
  return date.toDateString() === curDate.toDateString();
};

export const isDateTomorrow = (date: Date, curDate = new Date()): boolean => {
  const tommorowDate = new Date(curDate);
  tommorowDate.setDate(curDate.getDate() + 1);
  return date.toDateString() === tommorowDate.toDateString();
};

export const isDatePast = (date: Date, curDate = new Date()): boolean => {
  const curDateWithoutTime = new Date(curDate);
  curDateWithoutTime.setHours(0, 0, 0, 0);

  const dateWithoutTime = new Date(date);
  dateWithoutTime.setHours(0, 0, 0, 0);

  return dateWithoutTime < curDateWithoutTime;
};
